<template>
  <div class="back-to-top" v-show="show" @click="handleBackToTopClick">
    <div class="arrow"></div>
    <div>返回顶部</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  mounted() {
    // window.addEventListener('scroll', () => {
    //   this.show = window.scrollY > 100
    // })
  },
  methods: {
    handleBackToTopClick() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="less" scoped>
.back-to-top {
  display: block;
  position: fixed;
  bottom: 294px;
  right: 0;
  z-index: 9990;
  width: 60px;
  height: 60px;
  background-color: #e61717;
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
  transition: padding 200ms;
  box-sizing: content-box;
  padding-right: 0;

  &:hover {
    padding-right: 20px;
  }

  .arrow {
    width: 15px;
    height: 15px;
    transform: rotateZ(45deg);
    border: 0;
    border-left: 1px solid #fff;
    border-top: 1px solid #fff;
    margin: 15px auto 5px;
  }
}
</style>
